module.exports = __webpack_public_path__ + "img/chengyun1.b69a0187.png";